module.exports = __webpack_public_path__ + "static/img/zbsmrz.3c075fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zbsmrz.png
// module id = 1458
// module chunks = 3